var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ChartCard',{staticClass:"leaderboard-events-card",attrs:{"title":"Events Top 3","is-loading":_vm.isLoading}},[_c('ChartWrapper',{attrs:{"width":"100%","height":"300","type":"bar","options":_vm.chartOptions,"data":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }